var map = {
	"./A_new_kind_of_buy": 37,
	"./A_new_kind_of_buy.json": 37,
	"./Add_in_commercemanager": 38,
	"./Add_in_commercemanager.json": 38,
	"./Bag_checkout": 39,
	"./Bag_checkout.json": 39,
	"./Catalogue": 40,
	"./Catalogue.json": 40,
	"./Commerce_manager_header": 41,
	"./Commerce_manager_header.json": 41,
	"./Content Commerce Spin": 42,
	"./Content Commerce Spin.json": 42,
	"./ContentManager": 43,
	"./ContentManager.json": 43,
	"./Demoscroll_desktop": 44,
	"./Demoscroll_desktop.json": 44,
	"./EcomContent": 45,
	"./EcomContent.json": 45,
	"./Exclusive_offer": 46,
	"./Exclusive_offer.json": 46,
	"./Flying_box": 47,
	"./Flying_box.json": 47,
	"./Join_us": 48,
	"./Join_us.json": 48,
	"./New_kind_of_buy_spin": 49,
	"./New_kind_of_buy_spin.json": 49,
	"./New_kind_of_buy_spin_Alt": 50,
	"./New_kind_of_buy_spin_Alt.json": 50,
	"./New_kind_of_buy_spin_old": 51,
	"./New_kind_of_buy_spin_old.json": 51,
	"./OneLineOfCode": 52,
	"./OneLineOfCode.json": 52,
	"./Open_Close_Shop_Desktop": 53,
	"./Open_Close_Shop_Desktop.json": 53,
	"./Open_Close_Shop_mobile": 54,
	"./Open_Close_Shop_mobile.json": 54,
	"./Partnership_handshake": 55,
	"./Partnership_handshake.json": 55,
	"./PerfectForSome": 56,
	"./PerfectForSome.json": 56,
	"./Publisher_page_header_animation_noMasks": 57,
	"./Publisher_page_header_animation_noMasks.json": 57,
	"./Seller_page_header_animation_white": 58,
	"./Seller_page_header_animation_white.json": 58,
	"./ShopReel": 59,
	"./ShopReel.json": 59,
	"./ShopScroll": 60,
	"./ShopScroll.json": 60,
	"./ShopVsEditorial": 61,
	"./ShopVsEditorial.json": 61,
	"./Shop_box_animation_product_page": 62,
	"./Shop_box_animation_product_page.json": 62,
	"./Shop_this_buttons": 63,
	"./Shop_this_buttons.json": 63,
	"./SpotinAnimatedLogo": 64,
	"./SpotinAnimatedLogo.json": 64,
	"./Spotin_Song": 65,
	"./Spotin_Song.json": 65,
	"./SuperSimpleIntegration_onscroll": 66,
	"./SuperSimpleIntegration_onscroll.json": 66,
	"./Super_simple_integration": 67,
	"./Super_simple_integration.json": 67,
	"./Timeline - desktop_100px": 68,
	"./Timeline - desktop_100px.json": 68,
	"./Timeline - mobile_15px": 69,
	"./Timeline - mobile_15px.json": 69,
	"./Timeline_desktop": 70,
	"./Timeline_desktop.json": 70,
	"./Timeline_desktop_mobile": 71,
	"./Timeline_desktop_mobile.json": 71,
	"./WavingHand": 72,
	"./WavingHand.json": 72,
	"./ecom_content": 73,
	"./ecom_content.json": 73,
	"./marketing_to_commerce": 74,
	"./marketing_to_commerce.json": 74,
	"./portal_dashboard": 75,
	"./portal_dashboard.json": 75,
	"./product_page_full_width_Desktop": 76,
	"./product_page_full_width_Desktop.json": 76,
	"./product_page_side_panel_Desktop": 77,
	"./product_page_side_panel_Desktop.json": 77,
	"./startpage_header_animation": 78,
	"./startpage_header_animation.json": 78
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;


//////////////////
// WEBPACK FOOTER
// ./assets/animations ^\.\/.*$
// module id = 392
// module chunks = 0